import { EDITOR_REQUIRED_ANCHORS } from '@editor/config/constants'
import { CuboidAnchorFrameProps } from '@editor/interfaces/canvas'
import { fixVertexOnNormal, pointsToVector3s } from '@editor/services/Points'

import { CuboidFrame } from './AnchorFrames'
import { Frame } from './Frame'

export const CuboidAnchorFrame = ({ id, points, mousePoint, color = 'white' }: CuboidAnchorFrameProps) => {
  if (!points) {
    return null
  }

  const anchorPoints = [...(points || [])]

  if (mousePoint) {
    anchorPoints.push(mousePoint)
  }

  if (!anchorPoints.length) {
    return null
  }

  return (
    <group renderOrder={1}>
      {anchorPoints.length <= 3 && (
        <Frame
          id={`${id}-frame`}
          points={fixVertexOnNormal(pointsToVector3s(anchorPoints)).map((v) => v.toArray())}
          color={color}
          needFillMissingPoint
        />
      )}
      {anchorPoints.length === EDITOR_REQUIRED_ANCHORS.cuboid && (
        <CuboidFrame framePoints={pointsToVector3s(anchorPoints)} baseDiameter={0} color={color} />
      )}
    </group>
  )
}

export default CuboidAnchorFrame
